import ctl from "@netlify/classnames-template-literals";

export const wrapper = ctl(`
  flex
  w-full
  flex-col
  gap-4
  p-3
  rounded-2xl
  transition-all
  duration-200
  ease-in
  bg-neutral-50
  lg:flex-row
  hover:bg-neutral-100
  hover:drop-shadow-lg
`);

export const wrapperDark = ctl(`
  flex
  w-full
  flex-col
  gap-4
  p-3
  rounded-2xl
  transition-all
  duration-200
  ease-in
  bg-neutral-800
  lg:flex-row
  hover:bg-neutral-700
  hover:drop-shadow-lg
`);

export const favouriteButtonWrapper = ctl(`
  flex 
  items-center 
  justify-center 
`);

export const fullImageContentWrapper = ctl(`
  relative 
  flex 
  h-full 
  z-20
  flex-col 
`);

export const imageOverlay = ctl(`
  absolute
  inset-0
  z-10
  bg-gradient-to-t
  from-[#303030]
  to-transparent
  rounded-2xl
`);

export const wrapperFullImage = ctl(`
  w-full
  relative
  min-h-[18rem]
  h-full
  p-3
  rounded-2xl
`);

export const imageContainer = ctl(`
  relative
  h-32
  overflow-hidden
  rounded-2xl
  w-full
  lg:w-1/3
`);

export const metadataContainer = ctl(`
  flex
  w-full
  z-20
  lg:w-2/3
  justify-between
  flex-col
  gap-y-4
`);

export const nameContainer = ctl(`
  min-h-[3rem]
  flex
  items-start
`);
